module.exports = __webpack_public_path__ + "static/fundacion_black-43ad1181c9f21afbe526deb5d11ca937.svg";